// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/tableColumns/customerColumn.js
// *******************************************************************************
// CUSTOMER COLUMN
// *******************************************************************************
import translateX from 'utils/translateX';

const customerColumn = buildColumnProps => ({
  key: 'customer',
  title: translateX('customer'),
  dataIndex: '__buyer',
  ...buildColumnProps('__buyer.fullName', { sort: false, search: false }),
  align: 'left',
  render: (_, record) => record?.__buyer?.fullName || record?.__buyer?.name || '—',
});

export default customerColumn;
